var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dryRunTransaction } from './dryRun';
import { getMoveErrorMessage } from './errorMaps';
let enabled = false;
let latest = null;
const listeners = new Set();
export const dryRunDebug = {
    setEnabled(value) {
        enabled = value;
    },
    isEnabled() {
        return enabled;
    },
    getLatest() {
        return latest;
    },
    subscribe(listener) {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    },
    clear() {
        latest = null;
        listeners.forEach((l) => l(null));
    },
    report(entry) {
        latest = entry;
        // Full diagnostics to the console for support/debugging.
        console.groupCollapsed(`%c[dry-run] ${entry.status.toUpperCase()} — ${entry.action} for ${entry.address}`, `color: ${entry.status === 'success' ? '#16a34a' : '#dc2626'}; font-weight: bold;`);
        if (entry.status === 'failure') {
            console.error('Raw error:', entry.rawError);
            console.error('Mapped message:', entry.mappedError);
        }
        else {
            console.log('Simulation succeeded (no signature attempted).');
        }
        console.log('Effects:', entry.effects);
        console.groupEnd();
        listeners.forEach((l) => l(entry));
    },
};
/**
 * Runs a dry run and, when admin debug mode is enabled, reports the full result
 * (raw + mapped error + effects) to the console and the debug UI. Returns the
 * same {@link DryRunOutcome} as {@link dryRunTransaction} so existing callers can
 * keep their success/failure branching unchanged.
 */
export function dryRunAndReport(transactionBlock, address, suiClient, action) {
    return __awaiter(this, void 0, void 0, function* () {
        let outcome;
        try {
            outcome = yield dryRunTransaction(transactionBlock, address, suiClient);
        }
        catch (err) {
            // A thrown error (e.g. build failure) is itself a diagnostic in admin mode.
            if (enabled) {
                const rawError = err instanceof Error ? err.message : String(err);
                dryRunDebug.report({
                    timestamp: Date.now(),
                    address,
                    action,
                    status: 'failure',
                    rawError,
                    mappedError: getMoveErrorMessage(rawError),
                    effects: null,
                });
            }
            throw err;
        }
        if (enabled) {
            dryRunDebug.report({
                timestamp: Date.now(),
                address,
                action,
                status: outcome.success ? 'success' : 'failure',
                rawError: outcome.success ? undefined : outcome.rawError,
                mappedError: outcome.success ? undefined : getMoveErrorMessage(outcome.rawError),
                effects: outcome.effects,
            });
        }
        return outcome;
    });
}
